import endpoints from '@constants/configs/endpoints';
import API from '../../../services/API';

import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { SPINNER_MESSAGES_IDS } from '@constants/common/miscellaneous';
import { STATES_TYPE } from '@constants/configs/states';

/************************
 # Async action creators
 ************************/
const actions = { setError, startSpinner, stopSpinner };

const getVoterRegistrationInitData = () => {
    return async (applicationId: string, dispatch: Function) => {
        dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
        const url = endpoints.VOTER_REGISTRATION_INIT_DATA.processReplacements({ applicationId });
        const data = await API.getData(url, dispatch, actions);
        dispatch(stopSpinner());
        return data;
    };
};

const saveVoterRegistrationData = () => {
    return async (payload: FormData, caseNumber: string, dispatch: Function) => {
        dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
        const url = endpoints.VOTER_REGISTRATION_SAVE_DATA.processReplacements({ caseNumber });
        const params = [url, payload, 'POST', true, undefined, 'multipart/form-data'];

        try {
            const data = await API.postData(params, dispatch, actions);

            if (data) {
                return data;
            } else {
                console.error('Cannot save voter registration', url);
                return null;
            }
        } catch (error) {
            console.error('Cannot save voter registration', url);
            return null;
        } finally {
            dispatch(stopSpinner());
        }
    };
};

const fetchCountiesForZipcode = () => {
    return async (state: STATES_TYPE, postalCode: string, dispatch: Function) => {
        const url = endpoints.COUNTIES_FOR_STATE_ENDPOINT.processReplacements({ state, postalCode });
        const params = [url, undefined, 'POST', false];
        try {
            const data = await API.postData(params, dispatch, actions);
            if (!Array.isArray(data)) {
                console.error('Invalid response for counties', data);
                return [];
            }
            return data;
        } catch (error) {
            console.error('Cannot fetch counties', url);
            return [];
        }
    };
};

const updateVoterRegistrationFlagData = () => {
    return async (applicationId: string, isVoterRegistration: boolean, dispatch: Function) => {
        dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
        const url = endpoints.VOTER_REGISTRATION_UPDATE_FLAG.processReplacements({ voterFlag: isVoterRegistration });
        const params = [url, applicationId, 'POST', true, undefined, 'text/plain', true, false, false];
        try {
            const data = await API.postData(params, dispatch, actions);
            if (data) {
                return data;
            } else {
                console.error('Cannot update voter registration flag', url);
                return null;
            }
        } catch (error) {
            console.error('Cannot update voter registration flag', url);
            return null;
        } finally {
            dispatch(stopSpinner());
        }
    };
};

export {
    getVoterRegistrationInitData,
    saveVoterRegistrationData,
    fetchCountiesForZipcode,
    updateVoterRegistrationFlagData,
};
